import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table
} from "reactstrap";
import React, {Component, Fragment} from "react";
import {getFormFieldValue, setFormFieldValue} from "../Applications/shared/shared";
import {getData} from "../../api/doLogin";
import {getLMSWBlacklistStatus} from "../../constants/LMSConstants";
import {EventClient} from "../../util/eventClient";
import {hasPermission, RequiredPermission} from "../../api/permissionHelper";
import {NewBreadcrumb} from "../../components/Breadcrumb/NewBreadcrumb";
import {getGlobalState} from "../../constants/GlobalStore";
import NestedDropdown from "./components/NestedDropdown";
import {DropSelection} from "./components/DropSelection";

export class LeadBrowse extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      data: [],
      totalResults: 0,
      formData: {},
      showIndicator: false,
      page: 1,
      limit: 30,
      sort: null,
      breadcrumbs: [],
      calendarMenu: []
    }
  }

  // locationState(props = this.props) {
  //   return props['location'] && props.location['state'] || undefined;
  // }

  componentDidMount() {
    // console.log(this.locationState());
    if (this.props.match.params.folder_id) {
      this.search();
    }
    // console.log(getGlobalState("lmsMenu"));
    // EventClient.emit("LMS_ENTRY_EDIT", 37131);
    EventClient.on("LMS_LIST_RELOAD", () => this.search(this.state.page || 1), "LeadSearch");
  }

  componentWillUnmount() {
    EventClient.off('LMS_LIST_RELOAD', () => false, "LeadSearch");
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.match.params.folder_id !== this.props.match.params.folder_id) {
      this.search();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    // like writing return true
    return this.state.formData !== nextState.data || this.state.data !== nextState.data;
  }

  formsUpdater(evt) {
    setFormFieldValue(evt.target.id, evt.target.value, this.state['formData'], false, (data) => this.setState({formData: data}));
  }

  setSort(val) {
    if (this.state.sort === val) {
      this.setState({sort: null}, () => {
        this.search(this.state.page);
      });
    } else {
      this.setState({sort: val}, () => {
        this.search(this.state.page);
      });
    }
  }

  search(page = 1) {
    var self = this;
    const searchData = {
      q: this.state.formData['q'] || "",
      page: page,
      limit: this.state.limit,
      fid: this.props.match.params.folder_id || 0,
      recursive: this.state.formData['recursive'] || false,
      all: true
    };
    if (this.state.sort) {
      searchData.sort = this.state.sort;
    }
    // if (this.state.formData['all']) {
    //   searchData['all'] = true;
    // }
    self.setState({showIndicator: true});
    getData("lms/leads", searchData, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          // console.log(data.data);
          self.setState({
            data: data.data.leads,
            dataLoaded: true,
            showIndicator: false,
            page: Number(data.data.page),
            totalResults: Number(data.data.results),
            limit: Number(data.data.limit),
            breadcrumbs: data.data.folderPath || [],
            calendarMenu: data.data.calendarMenu || []
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  needsPages() {
    return this.state.totalResults > this.state.limit;
  }

  maxPages() {
    return Math.ceil(this.state.totalResults / this.state.limit);
  }

  onSelect(leadId) {
    EventClient.emit("LMS_ENTRY_EDIT", leadId.id);
  }

  render() {
    let calendarMenu = (this.state.calendarMenu || []).filter((cal) => cal.fwrite === 1).map((cal) => ({
      display: `${cal.fname} ${cal.lname}`.trim(),
      value: cal.uid
    })).sort((a, b) => a.display.localeCompare(b.display));

    let thisFolder = this.state.breadcrumbs.length > 0 ? this.state.breadcrumbs[this.state.breadcrumbs.length - 1].display || "this" : "this";

    return (
      <Card>
        <CardHeader>
          {/*<div style={{flex: 1, height: 23}}>*/}
          <NestedDropdown options={getGlobalState("lmsMenu")}
                          openDirection={"right"}
                          displayText={"Marketing Manager"}
                          onClick={(id) => EventClient.emit("NAVIGATE", `/leads/${id || ""}`)}/>
          {/*</div>*/}

          <div className="card-actions">
            {hasPermission(RequiredPermission.LMSSave) && (
              <button
                onClick={() => EventClient.emit("LMS_ENTRY_LOOKUP", {
                  fid: this.props.match.params.folder_id || 1,
                  folderPath: this.state.breadcrumbs.filter((crumb) => crumb.display !== "/").map((crumb) => crumb.display).join("/")
                })}
                title={"Add Lead"}
                key={"addlead"}
              >
                <small className="text-muted">
                  <i className="fa fa-plus fa-lg" style={{position: "relative", fontSize: 30}}/>
                </small>
              </button>
            )}

            <button
              onClick={() => EventClient.emit("LMS_LIST_RELOAD")}
              title={"Refresh Folder"}
              key={"refresh"}
            >
              <small className="text-muted">
                <i className="fa fa-refresh fa-lg" style={{position: "relative", fontSize: 25}}/>
              </small>
            </button>

          </div>

        </CardHeader>
        <CardBody>
          <Row>
            <NewBreadcrumb crumbs={this.state.breadcrumbs}
                           onClick={(id) => EventClient.emit("NAVIGATE", `/leads/${id || ""}`)}/>
            <Col xs="3">
              <FormGroup>
                {/*<Label for="psk">Search</Label>*/}
                <Input
                  placeholder={"Search criteria"}
                  type="text"
                  id="q"
                  autoFocus
                  value={getFormFieldValue(this.state.formData['q'])}
                  onChange={(evt) => this.formsUpdater(evt)}
                  onKeyPress={(event) => {
                    if (event.key === 'Enter') {
                      this.search()
                    }
                  }}
                />
              </FormGroup>
            </Col>
            <Col xs="2">
              <Button onClick={() => this.search()}>Search</Button>
            </Col>
            <Col xs="3">
              <FormGroup check className="checkbox">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  id="recursive"
                  name="recursive"
                  value="1"
                  checked={this.state.formData['recursive'] || false}
                  onChange={(evt) => {
                    if (this.state.formData['recursive']) {
                      this.setState({formData: {...this.state.formData, recursive: false}});
                    } else {
                      this.setState({formData: {...this.state.formData, recursive: true}});
                    }
                  }}
                />
                <Label check className="form-check-label" htmlFor="checkbox1">Recursive (Slower)</Label>
              </FormGroup>
            </Col>
            <Col xs="2">
              <DropSelection displayText={`Result Limit: ${this.state.limit}`}
                             bold
                             hideButton
                             items={{
                               page_limit: {
                                 // header: "Sort By",
                                 options: [10, 20, 30, 50, 75, 100, 200],
                                 selected: []
                               }
                             }}
                             onClick={(key, val) => {
                               if (key === "page_limit") {
                                 this.setState({limit: val}, () => {
                                   this.search(this.state.page);
                                 });
                               }
                             }}
              />
            </Col>
            {this.state.showIndicator && (
              <Col xs="1">
                <div className="sk-three-bounce" style={{margin: "7px auto"}}>
                  <div className="sk-child sk-bounce1"></div>
                  <div className="sk-child sk-bounce2"></div>
                  <div className="sk-child sk-bounce3"></div>
                </div>
              </Col>
            )}

          </Row>
          {this.state.dataLoaded ? this.state.data.length > 0 ? (
            <Fragment>
              <Table responsive size="sm">
                <thead>
                <tr>
                  <th>
                    <DropSelection displayText={"Name"}
                                   bold
                                   hideButton
                                   items={{
                                     sort_by: {
                                       header: "Sort By",
                                       options: ["Ascending", "Descending"],
                                       selected: []
                                     }
                                   }}
                                   onClick={(key, val) => {
                                     if (key === "sort_by") {
                                       if (val === "Ascending") {
                                         this.setSort("default");
                                       } else {
                                         this.setSort("desc");
                                       }
                                     }
                                   }}
                    />
                  </th>
                  <th>
                    <DropSelection displayText={"Location"}
                                   bold
                                   hideButton
                                   items={{
                                     sort_by: {
                                       header: "Sort By",
                                       options: ["Ascending", "Descending"],
                                       selected: []
                                     }
                                   }}
                                   onClick={(key, val) => {
                                     if (key === "sort_by") {
                                       if (val === "Ascending") {
                                         this.setSort("zip");
                                       } else {
                                         this.setSort("zipDesc");
                                       }
                                     }
                                   }}
                    />
                  </th>
                  <th>
                    <DropSelection displayText={"Status"}
                                   bold
                                   hideButton
                                   items={{
                                     sort_by: {
                                       header: "Sort By",
                                       options: ["Ascending", "Descending"],
                                       selected: []
                                     }
                                   }}
                                   onClick={(key, val) => {
                                     if (key === "sort_by") {
                                       if (val === "Ascending") {
                                         this.setSort("status");
                                       } else {
                                         this.setSort("statusDesc");
                                       }
                                     }
                                   }}
                    />
                  </th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                {this.state.data.map((lead, index) => {
                  const status = getLMSWBlacklistStatus(lead);
                  return <tr key={index}>
                    <td>
                      {`${lead['rank']} ${lead['fname']} ${lead['lname']}`}
                      {this.state.formData.recursive && (
                        <Fragment>
                          <br/>
                          <span style={{fontSize: 10}}>
                          <strong>Path:</strong>
                            {lead['fullPath'] || thisFolder}
                        </span>
                        </Fragment>
                      )}
                    </td>
                    <td>{`${lead['city']}, ${lead['state']} ${lead['branch']}`}</td>
                    <td><Badge style={{backgroundColor: status.bgColor, color: status.color}}>{status.display}</Badge>
                    </td>
                    <td style={{display: "flex"}}>
                      <Button onClick={(evt) => {
                        this.onSelect(lead)
                      }}>View</Button>
                      <DropSelection displayText={"Schedule"}
                                     items={{
                                       calendar: {
                                         header: "Select Calendar...",
                                         options: calendarMenu,
                                         selected: []
                                       }
                                     }}
                                     onClick={(category, value) => {
                                       window.open(`/calendar/${value || getGlobalState('loginID')}/schedule/${lead.id}`)
                                     }}
                      />
                    </td>
                  </tr>
                })}
                </tbody>
              </Table>
              <Pagination>
                {this.needsPages() && this.state.page > 1 && (
                  <PaginationItem><PaginationLink previous onClick={(evt) => {
                    this.search(Number(this.state.page) - 1);
                  }}>Prev</PaginationLink></PaginationItem>
                )}

                {this.generatePageLinks().map((page, index) => {
                  return <PaginationItem active={page.active} key={index}>
                    <PaginationLink onClick={() => {
                      if (!page.active) {
                        this.search(page.num);
                      }
                    }}>{page.num}</PaginationLink>
                  </PaginationItem>
                })}

                {this.needsPages() && this.state.page < this.maxPages() && (
                  <PaginationItem><PaginationLink next onClick={(evt) => {
                    this.search(Number(this.state.page) + 1);
                  }}>Next</PaginationLink></PaginationItem>
                )}
              </Pagination>
            </Fragment>
          ) : (
            <div>No results try your request again with different parameters</div>
          ) : (
            <div>Select Marketing Manager folder above or enter your search criteria above to search for user</div>
          )}
        </CardBody>
      </Card>
    );
  }

  generatePageLinks() {
    const pages = [];
    let maxPages = this.maxPages();
    if (maxPages > 15) {
      maxPages = 16
    }
    for (let pageNum = 0; pageNum < maxPages; pageNum++) {
      pages.push({
        num: pageNum + 1,
        active: pageNum + 1 === Number(this.state.page)
      });
    }
    return pages;
  }
}



// WEBPACK FOOTER //
// ./src/containers/Leads/LeadBrowse.js